<template>
  <div class="sent-notifications-table">
    <div class="text-h6 mb-4">Odeslané notifikace</div>
    <v-row class="mb-2">
      <v-col md="4">
        <InputSearchQuery label="Hledat uživatele" @search="searchByUser" />
      </v-col>
    </v-row>

    <DataTable
      :loading="loading"
      :headers="headers"
      :items="items"
      :metadata="metadata"
      @updateFooterOptions="updateFooterOptions"
    >
      <template #item.title="{ item }">
        <span
          style="
            max-width: 220px;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          {{ item.title }}
        </span>
      </template>

      <template #item.body="{ item }">
        <span
          class="grey--text text--darken-1"
          style="
            max-width: 220px;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          {{ item.body || "—" }}
        </span>
      </template>

      <template #item.occurredAt="{ item }">
        {{ getCzechDate(item.occurredAt) }}
      </template>

      <template #item.type="{ item }">
        {{ getTypeLabel(item.type) }}
      </template>

      <template #item.recipient="{ item }">
        {{ item.recipient ? item.recipient.email : "—" }}
      </template>

      <template #item.detail="{ item }">
        <v-btn text color="primary" outlined small @click="detailItem = item">
          Detail
        </v-btn>
      </template>
    </DataTable>

    <AppDialog
      :show-dialog="!!detailItem"
      title="Detail odeslané notifikace"
      hide-actions
      @closeDialog="detailItem = null"
    >
      <div v-if="detailItem">
        <div class="mb-3">
          <small class="grey--text">Nadpis</small>
          <div style="word-break: break-word">{{ detailItem.title }}</div>
        </div>
        <div class="mb-3">
          <small class="grey--text">Text</small>
          <div style="word-break: break-word; white-space: pre-wrap">
            {{ detailItem.body || "—" }}
          </div>
        </div>
        <div class="mb-3">
          <small class="grey--text">Typ</small>
          <div>{{ getTypeLabel(detailItem.type) }}</div>
        </div>
        <div v-if="detailItem.actionLink" class="mb-3">
          <small class="grey--text">Odkaz</small>
          <div style="word-break: break-word">{{ detailItem.actionLink }}</div>
        </div>
        <div class="mb-3">
          <small class="grey--text">Příjemce</small>
          <div>
            {{ detailItem.recipient ? detailItem.recipient.email : "—" }}
          </div>
        </div>
        <div class="mb-3">
          <small class="grey--text">Datum odeslání</small>
          <div>{{ getCzechDate(detailItem.occurredAt) }}</div>
        </div>
      </div>
    </AppDialog>
  </div>
</template>

<script>
import DataTable from "../elements/DataTable.vue";
import AppDialog from "../elements/AppDialog.vue";
import InputSearchQuery from "../elements/InputSearchQuery.vue";
import useNotifications from "../../use/useNotifications";
import useFormatDate from "../../use/formatDate";
export default {
  name: "SentNotificationsTable",

  components: { DataTable, AppDialog, InputSearchQuery },

  setup() {
    const { getNotifications } = useNotifications();
    const { getCzechDate } = useFormatDate();
    return { getNotifications, getCzechDate };
  },

  data() {
    return {
      loading: false,
      detailItem: null,
      items: [],
      metadata: { totalRecords: 0 },
      tableParams: { skip: 0, take: 10 },
      searchQuery: null,
      headers: [
        { text: "Příjemce", value: "recipient", sortable: false },
        { text: "Typ", value: "type", sortable: false },
        { text: "Nadpis", value: "title", sortable: false },
        { text: "Text", value: "body", sortable: false },
        { text: "Datum odeslání", value: "occurredAt", sortable: false },
        { text: "", value: "detail", sortable: false, align: "right" },
      ],
      typeLabels: {
        AdminNotification: "Oznámení od administrátora",
        MessageFromAdmin: "Zpráva od administrátora",
      },
    };
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const result = await this.getNotifications({
          skip: this.tableParams.skip,
          take: this.tableParams.take,
          orderBy: "occurredAtDesc",
          searchQuery: this.searchQuery,
        });
        if (result) {
          this.items = result.notifications || [];
          this.metadata = result.metadata || {
            totalRecords: this.items.length,
          };
        }
      } finally {
        this.loading = false;
      }
    },

    async updateFooterOptions(event) {
      this.tableParams.skip = event.page * event.itemsPerPage;
      this.tableParams.take = event.itemsPerPage;
      await this.fetchData();
    },

    async searchByUser(query) {
      this.searchQuery = query || null;
      this.tableParams.skip = 0;
      await this.fetchData();
    },

    getTypeLabel(type) {
      return this.typeLabels[type] || type;
    },

    refresh() {
      this.fetchData();
    },
  },
};
</script>
